import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Minus = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M4,9 L16,9 C16.5522847,9 17,9.44771525 17,10 C17,10.5522847 16.5522847,11 16,11 L4,11 C3.44771525,11 3,10.5522847 3,10 C3,9.44771525 3.44771525,9 4,9 Z"
				id="minus"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Minus.propTypes = {
	color: PropTypes.string,
};

export default Minus;
